// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Gn-z","tupacHeader":"Hn-z","tupacHeader2":"In-z","tupacMenu":"Jn-z","tupacMenu2":"Kn-z","tupacMain":"Ln-z","tupacMain2":"Mn-z"};